<script setup>
import {onMounted, ref} from "vue";
import FormTooltip from "@/components/FormTooltip";
import {useRoute} from "vue-router";
import i18n from "@/i18n";

const {t, te} = i18n.global

const props = defineProps({
  id: {
    type: String,
    required: true
  },
  type: {
    type: String,
    default: 'text'
  },
  pattern: {
    type: String,
    default: '.*'
  },
  modelValue: {
    type: String,
    required: false
  },
  disabled: {
    type: Boolean,
    default: false
  },
  required: {
    type: Boolean,
    default: false
  },
  autofocus: {
    type: String
  },
  autocomplete: {
    type: String
  },
  labelGroup: {
    type: String,
    required: true
  }
});

const emit = defineEmits(['update:modelValue']);
const inputValue = ref(props.disabled ? props.modelValue : (useRoute()?.query[props.id] ?? props.modelValue));

onMounted(() => {
  if (inputValue.value) {
    emit('update:modelValue', inputValue.value);
  }
});
</script>

<template>
  <div class="form-group mt-3">
    <label :for="id" :class="{'mb-1': true, 'required' : props.required}">
      {{ t(`${props.labelGroup}.label`) }}
    </label>
    <form-tooltip :label="`${props.labelGroup}.info`"/>

    <div class="input-group" v-if="te(`${props.labelGroup}.postfix`)">
      <input
          class="form-control"
          :disabled="props.disabled"
          :required="props.required"
          :type="props.type"
          :pattern="props.pattern"
          :id="props.id"
          :name="props.id"
          v-model="inputValue"
          :autofocus="props.autofocus"
          :autocomplete="props.autocomplete"
          :placeholder="te(`${props.labelGroup}.placeholder`) ? t(`${props.labelGroup}.placeholder`) : null"
          @input="(event) => emit('update:modelValue', event.target.value)"
      />
      <span class="input-group-text">{{ t(`${props.labelGroup}.postfix`) }}</span>
    </div>
    <input
        v-else
        class="form-control"
        :disabled="props.disabled"
        :required="props.required"
        :type="props.type"
        :pattern="props.pattern"
        :id="props.id"
        :name="props.id"
        v-model="inputValue"
        :autofocus="props.autofocus"
        :autocomplete="props.autocomplete"
        :placeholder="te(`${props.labelGroup}.placeholder`) ? t(`${props.labelGroup}.placeholder`) : null"
        @input="(event) => emit('update:modelValue', event.target.value)"
    />

  </div>
</template>